import React, {FC, useEffect} from 'react';
import {Navigate, Outlet, useLocation} from 'react-router-dom';
import {useDefineSettings} from '../../hooks/useDefineSettings';
import {SettingsDropdown} from './Components/SettingsDropdown';
import {useProfiles} from '../../react-sdk/queries';
import {Spinner} from '../../Components';
import {URLS} from '../../Routing';

export const Settings: FC = () => {
  const location = useLocation();
  const options = useDefineSettings();
  const profilesQuery = useProfiles();

  useEffect(() => {
    document.getElementById('verdocs-dropdown-menu-items')?.remove();
  });

  const current = options.find((option) => location.pathname === option.to || location.pathname.startsWith(`${option.to}/`));
  if (current?.disabled) {
    return profilesQuery.isSuccess ? (
      <Navigate to={URLS.SETTINGS_PROFILE.build()} replace />
    ) : (
      <div className="flex flex-1 items-center justify-center">
        <Spinner mode="dark" />
      </div>
    );
  }

  return (
    <div className="flex flex-col tablet:flex-row w-full h-full overflow-y-scroll">
      <SettingsDropdown />

      <div className="flex flex-col h-full p-4 tablet:p-6 flex-1 overflow-x-hidden">
        <Outlet />
      </div>
    </div>
  );
};
